// Utilidades y helpers

export const generateSessionId = (): string => {
  return `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const formatDate = (date: Date): string => {
  return new Intl.DateTimeFormat('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

export const calculateReadingTime = (wordCount: number): number => {
  // Promedio de 200 palabras por minuto
  return Math.ceil(wordCount / 200);
};

export const countWords = (text: string): number => {
  return text.trim().split(/\s+/).length;
};

export const truncate = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const extractKeywords = (text: string, count = 5): string[] => {
  // Palabras comunes a ignorar
  const stopWords = new Set([
    'el', 'la', 'de', 'que', 'y', 'a', 'en', 'un', 'ser', 'se',
    'no', 'haber', 'por', 'con', 'su', 'para', 'como', 'estar',
    'tener', 'le', 'lo', 'todo', 'pero', 'más', 'hacer', 'o',
    'poder', 'decir', 'este', 'ir', 'otro', 'ese', 'si', 'me',
    'ya', 'ver', 'porque', 'dar', 'cuando', 'él', 'muy', 'sin',
  ]);

  const words = text
    .toLowerCase()
    .replace(/[^\w\sáéíóúñü]/gi, '')
    .split(/\s+/)
    .filter(word => word.length > 3 && !stopWords.has(word));

  const frequency: Record<string, number> = {};
  words.forEach(word => {
    frequency[word] = (frequency[word] || 0) + 1;
  });

  return Object.entries(frequency)
    .sort((a, b) => b[1] - a[1])
    .slice(0, count)
    .map(([word]) => word);
};

export const exportToHTML = (article: { title: string; content: string; metadata: any }): string => {
  return `<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${article.metadata.metaTitle || article.title}</title>
    <meta name="description" content="${article.metadata.metaDescription || ''}">
    <meta name="keywords" content="${article.metadata.keywords?.join(', ') || ''}">
    <style>
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            line-height: 1.6;
            max-width: 800px;
            margin: 0 auto;
            padding: 2rem;
            color: #333;
        }
        h1 { font-size: 2.5rem; margin-bottom: 1rem; }
        h2 { font-size: 2rem; margin-top: 2rem; }
        h3 { font-size: 1.5rem; margin-top: 1.5rem; }
        p { margin-bottom: 1rem; }
        img { max-width: 100%; height: auto; }
    </style>
</head>
<body>
    <article>
        <h1>${article.title}</h1>
        ${article.content}
    </article>
</body>
</html>`;
};

export const downloadFile = (content: string, filename: string, type = 'text/html') => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    return false;
  }
};






